import React from 'react';
import './blog-post.css';
import Fall22MM1group from './pictures/Fall22MM1group.jpg';
import Fall22MM1wait from './pictures/Fall22MM1wait.jpg';
import Fall22MM1talk from './pictures/Fall22MM1talk.jpg';


//import reportWebVitals from './reportWebVitals';

const GHCTapia22Recap = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>WiC Fall 2022 Member Meeting 1 Recap</h2>
                    <p className="site-post-meta">October 7, 2022</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        Last week we held our first Member Meeting of the school year and quarter!
                    </p>
                    <p>
                        We started the meeting off by introducing the club and officer team to our
                        attendees. Afterwards we spent most of our time getting to know each other
                        with different prompts. Along with hot takes like “What’s the best boba
                        place on the Ave?” to “ 8:30 AM class or 9 PM class?”.  We then got to
                        introduce our 3 committees to the club, Social Events, Social Media, and
                        Outreach, because applications opened that very night! To end the meeting
                        we raffled off some allen school swag to 4 of our members.
                    </p>
                    <p>
                        Thank you so much to everyone who attended - we hope you had a wonderful time
                        and got to meet some great new friends!
                    </p>

                    <img src={Fall22MM1group} alt="Fall 2022 Member Meeting 1" />
                    <img src={Fall22MM1wait} alt="Fall 2022 Member Meeting 1" />
                    <img src={Fall22MM1talk} alt="Fall 2022 Member Meeting 1" />
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default GHCTapia22Recap;